import { DELETE_TYPE, PRODUCT_INTEREST_STATUS } from '@/utils/enum';
import BaseModel from './Base.model';
import { ProductModel } from './Product.model';

export class LeadProductModel extends BaseModel {
  constructor(data = {}) {
    super({
      id: `${data.leadId}-${data.productId}`, // LeadProduct doesn't have a UUID id, it uses composite key
      createdAt: data.createdAt || null,
      updatedAt: data.updatedAt || null,
    });

    this.leadId = data.leadId || '';
    this.productId = data.productId || '';
    this.interestStatus =
      data.interestStatus || PRODUCT_INTEREST_STATUS.INTERESTED;
    this.deleted = data.deleted || DELETE_TYPE.AVAILABLE;

    // Relations
    this.product = ProductModel.fromJson(data.product || {});
  }

  static fromJson(data) {
    if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
      return new LeadProductModel();
    }
    return new LeadProductModel(data);
  }

  static fromJsonArray(dataArray) {
    if (!Array.isArray(dataArray)) {
      return [];
    }
    return dataArray.map((item) => LeadProductModel.fromJson(item));
  }
}
